export const alfiUserId = window.localStorage.getItem('alfiUserId');
export const alfiUserEmail = window.localStorage.getItem('alfiUserEmail');
export const ALFI_USER_ID = 'alfiUserId';
export const ALFI_USER_EMAIL = 'alfiUserEmail';
